import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LegalMentionService } from '../shared/services/core/legal-mention.service';

@Component({
  selector: 'app-legal-mentions',
  standalone: true,
  imports: [],
  templateUrl: './legal-mentions.component.html',
  styleUrl: './legal-mentions.component.scss',
})
export class LegalMentionsComponent implements OnDestroy, OnInit {
  private readonly _destroying$ = new Subject<void>();

  sanitizedContent: string = '';

  constructor(private readonly legalMentionService: LegalMentionService) {}

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  ngOnInit() {
    this.getLegalMentions();
  }

  private getLegalMentions(): void {
    this.legalMentionService.getLegalMentions().subscribe((content) => {
      this.sanitizedContent = content;
    });
  }
}
